import { render, staticRenderFns } from "./statsBestSalesProducts.vue?vue&type=template&id=6f39400a&scoped=true&"
import script from "./statsBestSalesProducts.vue?vue&type=script&lang=js&"
export * from "./statsBestSalesProducts.vue?vue&type=script&lang=js&"
import style0 from "./statsBestSalesProducts.vue?vue&type=style&index=0&id=6f39400a&lang=scss&scoped=true&"
import style1 from "./statsBestSalesProducts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39400a",
  null
  
)

export default component.exports